// 导入axios
import Vue from 'vue'
import axios from 'axios';
import { Toast } from 'vant';
Vue.use(Toast);

// 进行一些全局配置
// 公共路由(网络请求地址)
//axios.defaults.baseURL = /api  //'';
// 请求响应超时时间
axios.defaults.timeout = 5000;

axios.interceptors.request.use(
    config => {
		if(localStorage.getItem("token")) {
			config.headers.token = localStorage.getItem("token");
		}
		if(sessionStorage.getItem("token")) {
			config.headers.token = sessionStorage.getItem("token");
		}
        return config;
    },
    error => {
        //console.log(error);
        return Promise.reject();
    }
);
axios.interceptors.response.use(
    response => {
		if(response.status == 200) {
			if(response.data.status == 200) {
				return Promise.resolve(response);
			}else{
				//Toast(response.data.msg);
				return Promise.resolve(response);
			}
		}else {
			return Promise.reject(response);
		}
    },
    error => {
        if(error.response.status) {
			Toast(error.response.data.msg);
			return Promise.reject(error.response);
		}
    }
);

// 封装自己的get/post方法
export default {
  get: function(path = '', data = {}) {
    return new Promise(function(resolve, reject) {
      axios.get(path, {
        params: data
      })
        .then(function(response) {
			if(response.data.status == 200 || response.data.code == 200) {
				resolve(response.data);
			}else {
				Toast(response.data.msg);
				if(response.data.status == 99901) {
					sessionStorage.clear();
					localStorage.clear();
					setTimeout(() => {
						window.location.href = '/#/login'
					}, 500);
				}
			}
        })
        .catch(function(error) {
			reject(error);
        });
    });
  },
  post: function(path = '', data = {}) {
    return new Promise(function(resolve, reject) {
      axios.post(path, data)
        .then(function(response) {
			if(response.data.status == 200 || response.data.code == 200) {
				resolve(response.data);
			}else {
				Toast(response.data.msg);
				if(response.data.status == 99901) {
					sessionStorage.clear();
					localStorage.clear();
					setTimeout(() => {
						window.location.href = '/#/login'
					}, 500);
				}
			}
        })
        .catch(function(error) {
			reject(error);
        });
    });
  }
};